/**
 * @description API endpoint constants
 * @module Constants / API Endpoints
 */

// API endpoint paths
export const API_ENDPOINTS = {
  MY_MEMBERS: 'my_members',
  LIMITED_MEMBERS: 'limited_members',
}

// Expiry filter values (in days)
export const EXPIRY_FILTER_DAYS = {
  UPCOMING_7_DAYS: 8, // Send 8 for "upcoming in 7 days"
  UPCOMING_30_DAYS: 31, // Send 31 for "upcoming in 30 days"
  UPCOMING_60_DAYS: 61, // Send 61 for "upcoming in 60 days"
}

// API response field names
export const API_FIELD_NAMES = {
  LICENSE_RENEWAL_ENABLED: 'licenseRenewalEnabled',
  RENEWAL_DATE: 'renewalDate', // This will be accessed as item.license.renewalDate
}

// Renewal threshold values (in days)
export const RENEWAL_THRESHOLDS = {
  UPCOMING_7_DAYS: 7,
  UPCOMING_30_DAYS: 30,
  UPCOMING_60_DAYS: 60,
  MAX_RENEWAL_WINDOW: 60, // Maximum days before expiration to show renewal options
  MIN_RENEWAL_WINDOW: 1, // Minimum days before expiration to show renewal options
}
